export let colorObj = {
  'Inactive time': "#fff",
  "Cool down time": "#7daebc",
  'Unpacking time': "#ffa600e5",
  'Setup time': "#e77841",
  'Build time': "#00677d",
};
